import Vue from 'vue';
import Router from 'vue-router';
import Sidebar from './components/Sidebar.vue';
import Inicio from './components/Inicio.vue';
import CuentaCorriente from './components/CuentaCorriente.vue';
import MiCuenta from './components/MiCuenta.vue';
import Cuentas from './components/Cuentas.vue';

Vue.use(Router);

export default new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      redirect: 'inicio',
      name: 'Inicio',
      component: Sidebar,
      children: [
        {
          path: 'inicio',
          name: 'Principal',
          component: Inicio,
        },
        {
          path: 'cuentaCorriente',
          name: 'Cuenta Corriente',
          component: CuentaCorriente,
        },
        {
          path: 'miCuenta',
          name: 'Mi Cuenta',
          component: MiCuenta,
        },
        {
          path: 'cuentas',
          name: 'Cuentas',
          component: Cuentas,
        },
      ],
    },
  ],
});
